import { observable, action, makeObservable } from 'mobx';

interface IOpen {
  content: string;
  theme?: ITheme;
  onClose?(): void;
  autoHide?: boolean;
  actionButtonProps?: ActionButtonProps;
  actionText?: string;
  autoHideMs?: number;
}

interface ActionButtonProps {
  type?: 'button' | 'textLink';
  onClick?(): any;
  link?: string;
}

type IThemeFloatingNotification =
  | 'standard'
  | 'success'
  | 'destructive'
  | 'warning'
  | 'premium'
  | 'preview'
  | 'dark';
type IThemeNotification =
  | 'standard'
  | 'error'
  | 'success'
  | 'warning'
  | 'premium'
  | 'status-toast-error'
  | 'status-toast-warning';

type ITheme = IThemeFloatingNotification | IThemeNotification;
type IType = 'global' | 'local' | 'sticky';

export class NotificationStore {
  public isOpen: boolean = false;
  public theme?: ITheme;
  public autoHide: boolean = true;
  public actionButtonProps?: ActionButtonProps;
  public actionText?: string;

  public type: IType = 'sticky';
  public autoHideTimeout: number = 7000;
  public content?: string;
  public onClose?: () => void;
  private timeoutId?: NodeJS.Timeout;

  constructor(type?: IType) {
    makeObservable(this, {
      isOpen: observable,
      theme: observable,
      autoHide: observable,
      actionButtonProps: observable,
      actionText: observable,
      close: action.bound,
      open: action,
      openErrorToast: action,
      openWarningToast: action,
    });
    this.type = type ?? this.type;
  }

  public open({
    content,
    theme = 'success',
    onClose = this.close,
    autoHide = true,
    actionButtonProps,
    actionText,
    autoHideMs,
  }: IOpen) {
    this.clearTimeout();
    this.content = content;
    this.theme = theme;
    this.onClose = onClose;
    this.isOpen = true;
    this.autoHide = autoHide;
    this.actionButtonProps = actionButtonProps;
    this.actionText = actionText;
    if (autoHideMs !== undefined && autoHideMs > 0) {
      this.timeoutId = setTimeout(() => {
        this.close();
      }, autoHideMs);
    }
  }

  public close = () => {
    this.clearTimeout();
    this.isOpen = false;
    this.content = undefined;
    this.theme = undefined;
    this.onClose = undefined;
    this.actionButtonProps = undefined;
  };

  private clearTimeout(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
  }

  public openErrorToast(content: string, autoHideMs?: number): void {
    this.open({
      content,
      theme: 'status-toast-error',
      autoHide: true,
      autoHideMs,
    });
  }

  public openWarningToast(content: string, autoHideMs?: number): void {
    this.open({
      content,
      theme: 'status-toast-warning',
      autoHide: true,
      autoHideMs,
    });
  }
}
